import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isNullable } from '@qtek/shared/utils';

export function templateNameExistsValidator(
  existingTemplates: string[]
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (isNullable(control.value)) {
      return null;
    }

    const templateName = control.value.trim().toLowerCase();

    if (!existingTemplates || existingTemplates.length === 0) {
      return null;
    }

    const nameExists = existingTemplates.some(
      existingName => existingName.trim().toLowerCase() === templateName
    );

    return nameExists ? { templateNameExists: { value: control.value } } : null;
  };
}
